import { render, staticRenderFns } from "./anamnese.vue?vue&type=template&id=c2b87934&scoped=true"
import script from "./anamnese.vue?vue&type=script&lang=js"
export * from "./anamnese.vue?vue&type=script&lang=js"
import style0 from "./anamnese.vue?vue&type=style&index=0&id=c2b87934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b87934",
  null
  
)

export default component.exports